export const PLATFORMS = ["WEB", "ROKU", "IOS", "ANDROID", "HWA"];

export const SYSTEM_CONFIG_TEMPLATES = [
    {
        appName: "Capra App",
        version: "0.1",
        appIconPath: "URL TBD",
        helpUrl: "URL TBD",
        faqUrl: "URL TBD",
        menuCollection: [
            {
                id: "kids",
                text: "Home",
                menuUrl: "pkg:/images/home.png",
            },
            {
                id: "my-list",
                text: "My List",
                menuUrl: "pkg:/images/watchlist.png",
            },
            {
                id: "exit-kids",
                text: "Exit Kids",
                menuUrl: "pkg:/images/exitKids.png",
            },
        ],
        Logging: {
            LogLevel: {
                Default: "Warning",
            },
        },
    },
];

export const RAIL_LABEL: any = {
    hero_carousel: "Hero Carousel",
    poster_horizontal: "Poster Horizontal",
    poster_vertical: "Poster Vertical",
    continue_watching: "Continue Watching",
    genre: "Genres",
    thematic: "Thematic",
    singular_promo: "Singular Promo",
    episodic_rail: "Episodic Rail",
    my_list: "My List",
    popular_searches: "Popular Searches",
    no_results: "No Results",
    collections_rail: "Collections",
};

export const RAIL_TYPE = {
    hero: "hero",
    continue_watching: "continue_watching",
    others: "others",
};

export const SYNC_ACTIONS = {
    SYNCED_DATA: "SYNCED",
    DEACTIVATED_RESOURCE: "DEACTIVATED",
};

export const FILE_STATUS_COLORS = {
    RESTORED: "rgba(6,182,105,1)",
    RESTORE_IN_PROGRESS: "rgba(255, 152, 0, 1)",
    ARCHIVED: "rgba(255, 255, 255, 0.3)",
};
